import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import pwaApi from './services/pwaApi';
import syncManager from './services/syncManager';

const PwaAuthContext = createContext(null);

export function PwaAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Ripristina sessione da localStorage
  useEffect(() => {
    const token = localStorage.getItem('pwa_token');
    const savedUser = localStorage.getItem('pwa_user');
    if (token && savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch {
        localStorage.removeItem('pwa_token');
        localStorage.removeItem('pwa_user');
      }
    }
    setLoading(false);
  }, []);

  const login = useCallback(async (username, password) => {
    const result = await pwaApi.login(username, password);
    if (result.success) {
      localStorage.setItem('pwa_token', result.data.token);
      localStorage.setItem('pwa_user', JSON.stringify(result.data.user));
      setUser(result.data.user);

      // Scarica dati per offline dopo login
      try {
        await syncManager.downloadData();
      } catch (e) {
        console.warn('Download dati offline fallito:', e.message);
      }

      return result.data;
    }
    throw new Error(result.message || 'Login fallito');
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('pwa_token');
    localStorage.removeItem('pwa_user');
    setUser(null);
  }, []);

  const value = {
    user,
    isAuthenticated: !!user,
    loading,
    login,
    logout
  };

  return (
    <PwaAuthContext.Provider value={value}>
      {children}
    </PwaAuthContext.Provider>
  );
}

export function usePwaAuth() {
  const context = useContext(PwaAuthContext);
  if (!context) {
    throw new Error('usePwaAuth deve essere usato dentro PwaAuthProvider');
  }
  return context;
}

export default PwaAuthContext;
